import * as HttpService from "../../../../service/HttpService"

/** 报表模板 service **/


const BASIC_URL = HttpService.DOMAIN
const REBASIC_URL = "http://touchfish.top/mock/5ed31a3dc054360020e0281a/report-tempalte"

/**
 * 获取表计列表
 */

export const getMeterList = (data) => {
    return HttpService.post(BASIC_URL + "/pQRemote/getMeterList" , data);
}
/**
 * 表计类型模糊搜索
 */

export const getModelCodeByFuzzyList = (data) => {
    return HttpService.get(BASIC_URL + "/pQRemote/getModelCodeByFuzzyList?modelCode="+ data);
}
/**
 * 表计地址模糊搜索
 */

export const getDevMeterCommAddrByFuzzyList = (data) => {
    return HttpService.get(BASIC_URL + "/pQRemote/getDevMeterCommAddrByFuzzyList?devMeterCommAddr="+ data);
}

/**
 * 表计名称模糊搜索
 */

export const getDevMeterNameByFuzzyList = (data) => {
    return HttpService.get(BASIC_URL + "/pQRemote/getDevMeterNameByFuzzyList?devMeterName="+ data);
}

/**
 * 短信验证码
 */

export const smsVerificationCode= (code,type) => {
    return HttpService.post(BASIC_URL + "/agRoom/controlDeviceStateByCode?identifyCode="+ code +"&operationType=" +type);
}

/**
 * 获得操作记录
 */

export const getOperationRecords= (data) => {
    return HttpService.post(BASIC_URL + "/pQRemote/getOperationRecords", data);
}


/**
 * 设置启动方式(表计地址字符串、启动方式 0：手动 1：自动)
 */

export const setStartTheWay = (data) => {
    return HttpService.post(BASIC_URL + "/pQRemote/setStartTheWay",data);
}

/**
 * 开机、关机、清故障（表计地址字符串、 3：清故障   1：开机 2：关机）
 */

export const setDeviceState = (data) => {

    return HttpService.post(BASIC_URL + "/pQRemote/setDeviceState",data);
}

/**
 * 补偿模式选择
 */

export const setChooseMode = (data) => {
    return HttpService.post(BASIC_URL + "/pQRemote/setChooseMode",data);
}
